import { render } from "./EnjoySongCreate.vue?vue&type=template&id=7a22a3f8"
import script from "./EnjoySongCreate.vue?vue&type=script&lang=js"
export * from "./EnjoySongCreate.vue?vue&type=script&lang=js"
script.render = render

export default script